export default {
  list: [],
};
